// extracted by mini-css-extract-plugin
export default {"title":"Q1SZuC","autoCompleteContainer":"yHBUQN","autoComplete":"ZGjd0i"};